import { UseQueryOptions } from '@tanstack/react-query'

export type QueryOnlyOptions = Omit<
  UseQueryOptions<any, any, any, any>,
  'queryKey' | 'queryFn'
> & { params?: Record<string, any> }

interface FormDataEncoderConfig {
  fileFields: string[]
  excludeFields?: string[]
  walker?(key: string, value: any, fm: FormData): boolean
}

export function makeFormDataEncoder(confg: FormDataEncoderConfig) {
  function formDataEncoder(data: Record<string, any>) {
    const fm = new FormData()
    Object.keys(data).forEach((k) => {
      const value = data[k]
      if (confg.walker && confg.walker(k, value, fm)) {
        return
      }
      if (confg.excludeFields && confg.excludeFields.includes(k)) {
        return
      }
      if (confg.fileFields.includes(k)) {
        if (value instanceof File) {
          fm.append(k, value)
        } else if (typeof value === 'string') {
          if (!value.startsWith('http')) {
            fm.append(k, value)
          }
        } else if (value === null) {
          fm.append(k, '')
        }
      } else {
        if (Array.isArray(value)) {
          if (k === 'keywords') {
            value.forEach((v) => {
              fm.append('keywords', v)
            })
          } else if (k === 'related_clips_data') {
            value.forEach((v) => {
              fm.append('clips', v.id)
            })
          } else if (k === 'clips_data') {
            value.forEach((v) => {
              fm.append('clips', v.id)
            })
          } else if (k === 'suggested_clips_data') {
            value.forEach((v) => {
              fm.append('clips', v.id)
            })
          } else if (k === 'themes_data') {
            value.forEach((v) => {
              fm.append('themes', v.id)
            })
          } else if (
            k !== 'clips' &&
            k !== 'themes' &&
            k !== 'keywords_data' &&
            k !== 'keywords' &&
            k !== 'related_clips_data' &&
            k !== 'suggested_clips_data' &&
            k !== 'themes_data'
          ) {
            fm.append(k, JSON.stringify(value))
          }
        } else if (typeof value === 'object' && value !== null) {
          fm.append(k, JSON.stringify(value))
        } else if (value === null) {
          fm.append(k, '')
        } else {
          fm.append(k, String(value))
        }
      }
    })
    return fm
  }

  return formDataEncoder
}
